import React, {Fragment} from "react";
import {useSelector} from "react-redux";
import DeleteModal from "../../../components/Modal/DeleteModal";
import AlertForm from "../../../components/Modal/components/AlertForm";
import ListView from "../../../components/ContentDisplay/ListView";
import AlertHandoff from "../../../components/Modal/AlertHandoff";
import AlertsCard, {CustomRenderComponent} from "./alertsCard";
import {getListHeaders, ACTIONS_LIST, CUSTOM_RENDER_KEYS} from "./alertTable.constants";
import {getUserProfile} from "../../../redux/Selectors/users.selector";
import {useAlertSearchOptions} from "./useAlertSearchOptions";
import {useAlertTableActions} from "./useAlertTableActions";
import {useAlertTableData} from "./useAlertTableData";

const AlertsTable = () => {
  const {searchOptions} = useAlertSearchOptions();
  const userProfile = useSelector(getUserProfile);
  const isStaffOrSuperuser = Boolean(userProfile?.is_staff || userProfile?.is_superuser);
  const {alertsList, alertTotalCount, fetchAfterDelete, handleSearch, paginationConfig} =
    useAlertTableData();
  const {
    closeDeleteModal,
    closeEditModal,
    closeHandoffModal,
    handleActionSelection,
    handleDelete,
    handleToggle,
    isDeleteModalOpen,
    isEditModalOpen,
    isHandoffModalOpen,
    metricType,
    selectedRow,
  } = useAlertTableActions(fetchAfterDelete);

  return (
    <Fragment>
      {isDeleteModalOpen && (
        <DeleteModal
          header={"Delete Alert"}
          modalBody={"Are you sure you want to delete this alert ?"}
          onClose={closeDeleteModal}
          onDelete={handleDelete}
          open={isDeleteModalOpen}
        />
      )}
      {isHandoffModalOpen && (
        <AlertHandoff
          open={isHandoffModalOpen}
          onCancel={closeHandoffModal}
          alertId={selectedRow.id}
        />
      )}
      {isEditModalOpen && (
        <AlertForm
          closeAlertForm={closeEditModal}
          data={selectedRow}
          metricType={metricType}
          showAlertForm={isEditModalOpen}
        />
      )}
      <div className="table-container">
        <ListView
          listItems={alertsList}
          listHeaders={getListHeaders(isStaffOrSuperuser)}
          onSelectAction={handleActionSelection}
          withActions
          actionsList={ACTIONS_LIST}
          permsForActions={[]}
          totalCount={alertTotalCount}
          withPagination={paginationConfig}
          booleanAsToggle
          onClickToggle={handleToggle}
          withSearchQuery={true}
          searchPlaceHolder={"Filter Alerts"}
          customRenderKeys={CUSTOM_RENDER_KEYS}
          customRenderComponent={CustomRenderComponent}
          searchOptions={searchOptions}
          handleSearch={handleSearch}
          cardContent={(props) => (
            <AlertsCard {...props} isStaffOrSuperuser={isStaffOrSuperuser} />
          )}
        />
      </div>
    </Fragment>
  );
};

export default AlertsTable;
